import { Calendar } from "lucide-react";
import { useNavigate } from "react-router-dom";

function StatusPill({ status, isPastEvent }) {
  return (
    <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white text-gray-800 text-xs font-semibold">
      <span className={`w-3 h-3 rounded-full ${isPastEvent ? "bg-red-500" : "bg-green-500"}`} />
      {status}
    </span>
  );
}
export default function EventCard({ event }) {
  const navigate = useNavigate();
  const eventStartTime = event?.startDate ? new Date(event.startDate).getTime() : null;
  const isPastEvent = Number.isFinite(eventStartTime) ? eventStartTime < Date.now() : false;

  // Imagen por defecto
  const defaultImage =
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTE1BFq0h-RvrEBWCMPudD2QMYcG2BDJVDYNw&s";

  return (
    <div
      className="w-full rounded-3xl overflow-hidden bg-white cursor-pointer outline-none ring-offset-2 focus-visible:ring-2 focus-visible:ring-blue-600 shadow-sm hover:shadow-md transition-shadow"
      role="button"
      tabIndex={0}
      onClick={() => navigate(`/dashboard/events/${event?.id}`)}
      aria-label={`Open details for ${event?.name}`}
    >
      <div className="flex flex-col md:flex-row h-56">
        {/* Imagen */}
        <div className="md:w-1/2 h-1/2 md:h-full">
          <img
            src={event?.coverImage || defaultImage}
            alt={event?.name}
            className="w-full h-full object-cover"
            loading="lazy"
            draggable={false}
          />
        </div>

        {/* Info */}
        <div className="md:w-1/2 bg-gray-100 px-5 py-4 flex flex-col justify-between h-1/2 md:h-full">
          <div className="flex flex-wrap items-center gap-2">
            <StatusPill status={event?.status} isPastEvent={isPastEvent} />
              <span className="inline-flex items-center gap-1 px-4 py-2 rounded-full bg-white text-gray-900 text-xs font-semibold">
                <Calendar size={14} />
                {event?.startDate && `${new Date(event?.startDate).toLocaleString("en-GB")}`}
              </span>
          </div>

          <div>
            <div className="text-lg font-semibold text-gray-900">{event?.name}</div>
            <div className="text-gray-500 text-sm">
              {(event?.location || "").split(",").map((part, idx) => (
                <div key={idx}>{part.trim()}</div>
              ))}
            </div>
          </div>

          <div className="mb-2 flex items-center justify-between">
            <span className="text-sm text-gray-900">
              Attendees {event?.totalAttendees ?? 0}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
